import { FormikProps } from 'formik';
import { useRef, useState } from 'react';

import { useApplyFinalValidationOnBind } from './useApplyFinalValidationOnBind';
import { createSoftContinueSession, runSoftFormStepContinue } from '../validation/softContinue';

export function useFormStepContinueRef<T>() {
  const formikRef = useRef<FormikProps<T> | null>(null);
  const sessionRef = useRef(createSoftContinueSession());
  const [showSoftContinueHint, setShowSoftContinueHint] = useState(false);
  const { onFormikBound } = useApplyFinalValidationOnBind();

  function bindFormik(formik: FormikProps<T>) {
    formikRef.current = formik;
    onFormikBound(formik);
  }

  async function continueWithSoftValidation(onStepComplete: (values: T) => void) {
    const session = sessionRef.current;
    const proceeded = await runSoftFormStepContinue(formikRef.current, onStepComplete, session);
    setShowSoftContinueHint(!proceeded && session.proceedDespiteErrorsAcknowledged);
  }

  return { bindFormik, continueWithSoftValidation, showSoftContinueHint };
}
